import { useEffect } from 'react';
import { Hero } from './Hero/Hero';
import { Upcoming } from './upcoming/Upcoming';
import { useEventTracking } from 'hooks/useEventTracking';
import 'https://cdn.marmot-cloud.com/npm/hylid-bridge/2.10.0/index.js';

export const ConcertsPage = () => {
  const { eventTracking } = useEventTracking();
  useEffect(() => {
    eventTracking.page.viewed({
      pageName: 'concerts_page',
      url: window.location.href,
    });
  }, [eventTracking]);
  return (
    <>
      <Hero />
      <Upcoming />
    </>
  );
};
